import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, memo, Suspense } from 'react';
import { Box, styled } from '@mui/material';
import { DeviceModel } from 'z3k-settings/components/service/components/device-io-model/model/device-model-type';
const H2000PLUS_PRO_V2 = lazy(() => import(
// webpackChunkName: 'H2000PLUS_PRO_V2'
'console/entities/device.map.marker-model/model/icons/H2000+Pro.v2.svg'));
const H2000PLUS_PRO = lazy(() => import(
// webpackChunkName: 'H2000PLUS_PRO'
'console/entities/device.map.marker-model/model/icons/H2000+Pro.svg'));
const H2000PLUS = lazy(() => import(
// webpackChunkName: 'H2000PLUS'
'console/entities/device.map.marker-model/model/icons/H2000+.svg'));
const C2000PLUS = lazy(() => import(
// webpackChunkName: 'C2000PLUS'
'console/entities/device.map.marker-model/model/icons/C2000+.simple.svg'));
const H1500PLUS_PRO = lazy(() => import(
// webpackChunkName: 'H1500PLUS_PRO'
'console/entities/device.map.marker-model/model/icons/H1500+Pro.svg'));
const H1000PLUS = lazy(() => import(
// webpackChunkName: 'H1000PLUS'
'console/entities/device.map.marker-model/model/icons/H1000+.svg'));
const H1000PLUS_PRO = lazy(() => import(
// webpackChunkName: 'H1000PLUS_PRO'
'console/entities/device.map.marker-model/model/icons/H1000+Pro.svg'));
const H1000PLUS_PRO_V2 = lazy(() => import(
// webpackChunkName: 'H1000PLUS_PRO_V2'
'console/entities/device.map.marker-model/model/icons/H1000+Pro.v2.svg'));
const H700PLUS_PRO = lazy(() => import(
// webpackChunkName: 'H700PLUS_PRO'
'console/entities/device.map.marker-model/model/icons/H700+Pro.svg'));
const ZE22 = lazy(() => import(
// webpackChunkName: 'ZE22'
'console/entities/device.map.marker-model/model/icons/ze-22.svg'));
const ZE44 = lazy(() => import(
// webpackChunkName: 'ZE22'
'console/entities/device.map.marker-model/model/icons/ze-44.svg'));
const ZE66 = lazy(() => import(
// webpackChunkName: 'ZE66'
'console/entities/device.map.marker-model/model/icons/ZE66.svg'));
const ZE8482 = lazy(() => import(
// webpackChunkName: 'ZE8482'
'console/entities/device.map.marker-model/model/icons/ze-84e.svg'));
const ZE88 = lazy(() => import(
// webpackChunkName: 'ZE88'
'console/entities/device.map.marker-model/model/icons/ze-88.svg'));
const CLIMATIC = lazy(() => import(
// webpackChunkName: 'CLIMATIC'
'console/entities/device.map.marker-model/model/icons/climatic-io.svg'));
const EX77 = lazy(() => import(
// webpackChunkName: 'EX77'
'console/entities/device.map.marker-model/model/icons/ex-77.svg'));
const ZE00 = lazy(() => import(
// webpackChunkName: 'ZE00'
'console/entities/device.map.marker-model/model/icons/ze-00.svg'));
const Socket03 = lazy(() => import(
// webpackChunkName: 'Socket03'
'console/entities/device.map.marker-model/model/icons/socket-03.svg'));
const Fallback = styled('div')({});
export const DeviceIcon = memo(function DeviceIcon({ model, className, hardware, }) {
    let icon;
    switch (model) {
        case DeviceModel.H2000_PRO:
            if (hardware === 723) {
                icon = _jsx(H2000PLUS_PRO_V2, { className: className });
            }
            else {
                icon = _jsx(H2000PLUS_PRO, { className: className });
            }
            break;
        case DeviceModel['H2000+']:
            icon = _jsx(H2000PLUS, { className: className });
            break;
        case DeviceModel['C2000+']:
            icon = _jsx(C2000PLUS, { className: className });
            break;
        case DeviceModel.H1500_PRO:
            icon = _jsx(H1500PLUS_PRO, { className: className });
            break;
        case DeviceModel.H700_PRO:
            icon = _jsx(H700PLUS_PRO, { className: className });
            break;
        case DeviceModel.H1000_PRO:
            if (hardware === 722) {
                icon = _jsx(H1000PLUS_PRO_V2, { className: className });
            }
            else {
                icon = _jsx(H1000PLUS_PRO, { className: className });
            }
            break;
        case DeviceModel['H1000+']:
            icon = _jsx(H1000PLUS, { className: className });
            break;
        case DeviceModel.ZE22:
            icon = _jsx(ZE22, { className: className });
            break;
        case DeviceModel.ZE44:
            icon = _jsx(ZE44, { className: className });
            break;
        case DeviceModel.ZE66:
            icon = _jsx(ZE66, { className: className });
            break;
        case DeviceModel.ZE8482:
            icon = _jsx(ZE8482, { className: className });
            break;
        case DeviceModel.ZE88:
            icon = _jsx(ZE88, { className: className });
            break;
        case DeviceModel.CLIMATIC:
            icon = _jsx(CLIMATIC, { className: className });
            break;
        case DeviceModel.EX77:
            icon = _jsx(EX77, { className: className });
            break;
        case DeviceModel.ZE00:
            icon = _jsx(ZE00, { className: className });
            break;
        case DeviceModel.Socket03:
            icon = _jsx(Socket03, { className: className });
            break;
        default:
            icon = _jsx(Fallback, {});
    }
    return _jsx(Suspense, { fallback: _jsx(Fallback, {}), children: icon });
});
export const DeviceIconView = styled(Box)({
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    '& svg': {
        maxWidth: '100%',
        maxHeight: '100%',
    },
});
export function hasIconForModel(model) {
    if (model === null) {
        return false;
    }
    return model in DeviceModel;
}
